import { Link } from 'react-router-dom';
import { TermsHero } from '../components';
import './terms.css'
const TermsAndConditions = () => {
    return (
        <div className="terms-page">
            <TermsHero />
            <div className="legal-content-section">
                <div className="legal-content-container container">
                    <div className="legal-content-text">
                        Welcome to <span className="text-highlight">flowdo</span> (“we”, “our”, “us”). By signing up for and using flowdo’s services, you (“User”, “you”, “your”) agree to be bound by the following Terms and Conditions. Please read these carefully before accessing or using the platform.
                        If you do not agree with these Terms and Conditions, you should not use flowdo.<br />
                        <strong>1. About flowdo</strong>
                        flowdo is a digital platform developed and operated by Innate Technologies L.L.C-FZ, based in Dubai, United Arab Emirates, with a branch office in Kochi, Kerala, India.
                        flowdo currently offers <span className="text-highlight">Task Management services</span>, with future expansion into HR, Payroll, Inventory, Accounts, and other modules.<br />

                        <strong>2. Eligibility</strong>
                        <ol>
                            <li>• You must be have a working email address to register and start using the flowdo platform.</li>
                            <li>• By registering, you represent that all information provided is accurate, complete, and up to date.</li>
                            <li>• Companies registering on behalf of employees are responsible for ensuring their users comply with these Terms.</li>
                        </ol>
                        <strong>3. User Registration</strong>
                        <ol>
                            <li>• To sign up, users must provide their <span className="text-highlight">name, company name (optional), email, and mobile number.</span></li>
                            <li>• For adding additional users, the company administrator may register staff with their <span className="text-highlight">email, name, and mobile number.</span></li>
                            <li>• Email and mobile numbers will be used <span className="text-highlight">solely for communication related to flowdo</span> (e.g., notifications, reminders, service updates) <span className="text-highlight">and will not be used for marketing or shared with third parties.</span></li>
                        </ol>

                        <strong>4. Subscriptions & Payments</strong>
                        <ol>
                            <li>• flowdo offers both <span className="text-highlight">free and paid subscription models.</span></li>
                            <li>• Free subscriptions have limited features, while paid plans unlock additional functionality.</li>
                            <li>• Payments (if applicable) must be made in accordance with the plan chosen. Subscription fees are <span className="text-highlight">non-refundable</span>, except as required by law.</li>
                            <li>• We reserve the right to modify subscription models, pricing, or features, with prior notice.</li>
                        </ol>

                        <strong>5. Use of the Platform</strong>
                        <ol>
                            <li>• flowdo's Task Management system allows users to create, assign, and track tasks, with notifications and reminders sent via email or within the system.</li>
                            <li>• Users agree not to misuse the platform, including but not limited to:</li>
                            <ol>
                                <li> Uploading or sharing unlawful, offensive, or harmful content.</li>
                                <li> Attempting to hack, disrupt, or gain unauthorized access to the system.</li>
                                <li> Misrepresenting identity or company details.</li>
                            </ol>
                            <li>• Each user is responsible for the accuracy of the data they enter and for maintaining the confidentiality of their login credentials.</li>
                        </ol>
                        <strong>6. Data Privacy & Security</strong>
                        <ol>
                            <li>• All data entered into flowdo is <span className="text-highlight">owned by the registered company or individual user.</span></li>
                            <li>• flowdo will not access, view, edit, or share user data, except when:</li>
                            <ol>
                                <li> Explicitly authorized by the company administrator or user.</li>
                                <li> Required by law or regulatory authorities.</li>
                            </ol>
                            <li>• Data is securely stored using industry-standard security measures.</li>
                            <li>• By using flowdo, you consent to the collection and use of your information as described in our <span className="text-highlight"><Link to="/privacy-policy">Privacy Policy.</Link></span></li>
                        </ol>

                        <strong>7. Communications</strong>
                        <ol>
                            <li>• flowdo may send system notifications, reminders, or important service updates via <span className="text-highlight">email and/or SMS.</span></li>
                            <li>• These communications are essential to the functioning of the platform and cannot be opted out of, except by deleting your account.</li>
                        </ol>

                        <strong>8. Intellectual Property</strong>
                        <ol>
                            <li>• All intellectual property rights in flowdo, including software, design, logos, and trademarks, are owned by Innate Technologies L.L.C-FZ.</li>
                            <li>• Users are granted a limited, non-transferable, non-exclusive license to use the platform in accordance with these Terms.</li>
                            <li>• You may not copy, distribute, modify, or reverse-engineer any part of flowdo.</li>
                        </ol>

                        <strong>9. Limitation of Liability</strong>
                        <ol>
                            <li>• flowdo is provided on an "as-is" and "as-available" basis.</li>
                            <li>• While we strive to provide reliable and uninterrupted service, we make no guarantees regarding availability, accuracy, or performance.</li>
                            <li>• We are not responsible for any loss of data, business interruption, missed tasks, or damages resulting from use or inability to use flowdo.</li>
                            <li>• To the fullest extent permitted by law, our liability is limited to the amount you have paid (if any) for the subscription in the 12 months preceding the claim.</li>
                        </ol>

                        <strong>10. Termination</strong>
                        <ol>
                            <li>• Users may stop using flowdo at any time by deleting their account or by changing the subscription model.</li>
                            <li>• We reserve the right to suspend or terminate accounts if we believe there has been a violation of these Terms, fraudulent activity, or misuse of the platform.</li>
                        </ol>


                        <strong>11. Governing Law</strong>
                        <ol>
                            <li>• These Terms are governed by and construed under the laws of the <span className="text-highlight">United Arab Emirates.</span></li>
                            <li>• Any disputes shall be subject to the exclusive jurisdiction of the courts in Dubai, UAE.</li>
                        </ol>

                        <strong>12. Changes to Terms</strong>
                        <ol>
                            <li>• We may update these Terms from time to time. Changes will be effective once posted on our website.</li>
                            <li>• Continued use of flowdo after such changes constitutes acceptance of the revised Terms.</li>
                        </ol>
                        <strong>13. Contact Us</strong>
                        For questions or concerns regarding these Terms, please contact us at <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link> <br />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
